import GoogleDocsPng from '../../images/icons/google_docs.png'

const GoogleDocsLogo = () => <img src={GoogleDocsPng} alt="Google Docs" style={{ height: 24, paddingRight: 5 }} />

export default GoogleDocsLogo
